import styled from 'styled-components';

import { pxToRem } from '../../../utils/styles';
import Icon from '../Icon';
import { InputContainerStyleProps, InputStates } from './types';

export const LeftIconInput = styled(Icon)`
  &&&&&&&&& {
  }
`;
export const RightIconInput = styled(Icon)`
  &&&&&&&&& {
  }
`;

export const LabelContainer = styled.div`
  &&&&&&&&& {
    min-height: ${pxToRem(24)};

    display: flex;
    gap: ${pxToRem(10)};
    flex: none;
    order: 0;
    flex-grow: 0;
  }
`;

export const BaseInputField = styled.input<{ $state: InputStates }>`
  &&&&&&&&& {
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${pxToRem(8)};
    height: ${pxToRem(48)};
    width: 100%;
    background: ${({ theme: { colors } }) => colors.white};
    border: ${pxToRem(1)} solid ${({ theme: { colors } }) => colors.neutral400};
    color: ${({ theme: { colors } }) => colors.neutral500};
    flex: none;
    order: 1;
    align-self: stretch;
    flex-grow: 0;
    font-family: ${({ theme: { fonts } }) => fonts.secondary.normal.name};
    font-size: ${pxToRem(14)};

    ::placeholder,
    ::-webkit-input-placeholder {
      color: ${({ theme: { colors } }) => colors.neutral400};
    }

    ::-webkit-outer-spin-button,
    ::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }

    -webkit-box-shadow: 0 0 0px 1000px
      ${({ $state, theme: { colors } }) =>
        $state === 'inactive' ? 'transparent' : colors.white}
      inset;

    &[type='number'] {
      -moz-appearance: textfield;
    }

    &:focus {
      outline: none;
    }

    &:disabled {
      color: ${({ theme: { colors } }) => colors.neutral400};
    }
  }
`;

export const BaseTextAreaField = styled.textarea<{ $state: InputStates }>`
  &&&&&&&&& {
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${pxToRem(8)};
    height: ${pxToRem(98)};
    width: 100%;
    resize: none;
    background: ${({ theme: { colors } }) => colors.white};
    border: ${pxToRem(1)} solid ${({ theme: { colors } }) => colors.neutral400};
    color: ${({ theme: { colors } }) => colors.neutral500};
    flex: none;
    order: 1;
    align-self: stretch;
    flex-grow: 0;
    font-family: ${({ theme: { fonts } }) => fonts.secondary.normal.name};
    ::placeholder,
    ::-webkit-input-placeholder {
      color: ${({ theme: { colors } }) => colors.neutral400};
    }
    ::-webkit-outer-spin-button,
    ::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }
    -webkit-box-shadow: 0 0 0px 1000px
      ${({ $state, theme: { colors } }) =>
        $state === 'inactive' ? 'transparent' : colors.white}
      inset;
    &[type='number'] {
      -moz-appearance: textfield;
    }
    &:focus {
      outline: none;
    }
    &:disabled {
      color: ${({ theme: { colors } }) => colors.neutral400};
    }
  }
`;

export const InputContainer = styled.div<InputContainerStyleProps>`
  &&&&&&&&& {
    position: relative;
    width: 100%;

    ${BaseInputField} {
      padding: ${pxToRem(12)}
        ${({ $rightIconInput }) =>
          $rightIconInput ? pxToRem(48) : pxToRem(16)}
        ${pxToRem(12)}
        ${({ $leftIconInput }) => ($leftIconInput ? pxToRem(48) : pxToRem(16))};
    }

    ${LeftIconInput} {
      cursor: pointer;
      pointer-events: auto;
      position: absolute;
      top: calc(50% - ${pxToRem(12)});
      left: ${({ $leftIconInput }) => ($leftIconInput ? pxToRem(16) : 'unset')};
      animation: ${({ $leftIconInput }) =>
        $leftIconInput === 'Spinner' ? 'bhGTOD 1.2s ease infinite' : ''};
    }

    ${RightIconInput} {
      cursor: pointer;
      pointer-events: auto;
      position: absolute;
      top: calc(50% - ${pxToRem(12)});
      right: ${({ $rightIconInput }) =>
        $rightIconInput ? pxToRem(16) : 'unset'};
      animation: ${({ $rightIconInput }) =>
        $rightIconInput === 'Spinner' ? 'bhGTOD 1.2s ease infinite' : ''};
    }
  }
`;

export const HelpTextContainer = styled.div`
  &&&&&&&&& {
    min-height: ${pxToRem(16)};

    order: 2;
    align-self: stretch;
    flex-grow: 0;
  }
`;

export const BaseContainer = styled.div`
  &&&&&&&&& {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: ${pxToRem(8)};
    transition: all 0.2s;
  }
`;

export const ActiveContainer = styled(BaseContainer)`
  &&&&&&&&& {
  }
`;

export const InactiveContainer = styled(BaseContainer)`
  &&&&&&&&& {
    ${BaseInputField} {
      border: ${pxToRem(1)} solid
        ${({ theme: { colors } }) => colors.neutral300};
      background: ${({ theme: { colors } }) => colors.neutral100};
      cursor: default !important;
    }

    path {
      fill: ${({ theme: { colors } }) => colors.neutral200};
    }

    ${LabelContainer} {
      color: ${({ theme: { colors } }) => colors.neutral400};
    }
  }
`;

export const ErrorContainer = styled(BaseContainer)`
  &&&&&&&&& {
    ${BaseInputField} {
      border: ${pxToRem(1)} solid ${({ theme: { colors } }) => colors.error};
    }
  }
`;

export const SuccessContainer = styled(BaseContainer)`
  &&&&&&&&& {
    ${BaseInputField} {
      border: ${pxToRem(1)} solid ${({ theme: { colors } }) => colors.success};
    }
  }
`;

export const TextAreaContainer = styled.div`
  &&&&&&&&& {
    position: relative;
    width: 100%;
    ${BaseTextAreaField} {
      padding: ${pxToRem(12)};
    }
  }
`;
